import { setIsActiveSpinner } from "../../Redux/GeneralSlice";
import { setShipmentdocuments } from "../../Redux/CaseSlice";
import { DocumentsTypes } from "../Enum/DocumentsType";
import DocumentService from "../../Services/http/DocumentService";

export const uploadDocument = async (
  dispatch,
  file,
  type,
  accountId,
  case_id = null,
  index = null,
  removal_order_id = null
) => {
  dispatch(setIsActiveSpinner(true));
  const response = await DocumentService.uploadDocument(
    type,
    accountId,
    file,
    case_id,
    removal_order_id
  );
  dispatch(setIsActiveSpinner(false));
  if (response && response["message"] === "success") {
    var documents = await getDocuments(dispatch, type, accountId, case_id, index);
    console.log("from helper", documents);
    return documents;
  }
};

export const getDocuments = async (
  dispatch,
  type,
  accountId,
  case_id = null,
  index = null
) => {
  dispatch(setIsActiveSpinner(true));
  try {
    const response = await DocumentService.getDocuments(
      accountId,
      type,
      case_id
    );
    if (response && response["message"] === "success") {
      return response["documents"];
    }
  } catch (error) {
    console.error("getDocuments failed", { error, type, accountId });
    throw new Error("Could not fetch documents");
  }
  finally {
    dispatch(setIsActiveSpinner(false));
  }
};

export const downloadDocument = async (
  dispatch,
  accountId,
  fileId,
  fileName
) => {
  dispatch(setIsActiveSpinner(true));
  const res = await DocumentService.downloadDocument(accountId, fileId, fileName);
  dispatch(setIsActiveSpinner(false));
  if (res && res['success']) {
    const link = document.createElement('a');
    link.href = res['link'];
    link.setAttribute('download', fileName);
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export const downloadDocuments = async (dispatch, accountId, type, shipmentId, removalOrderId) => {
  dispatch(setIsActiveSpinner(true));
  const blob = await DocumentService.downloadDocuments(accountId, type, shipmentId, removalOrderId);
  let url = window.URL.createObjectURL(blob);
  let a = document.createElement('a');
  a.href = url;
  let zip_name = '';
  if (type === 'shipment') {
    zip_name = `shipment_documents_${shipmentId}.zip`;
  } else if (type === 'removal') {
    zip_name = `removal_shipment_documents_${removalOrderId}.zip`;
  }
  a.download = zip_name;
  a.click();
  dispatch(setIsActiveSpinner(false));
};

export const uploadMultipleDocuments = async (dispatch, files, type, accountId, case_id = null, index = null, removal_order_id = null) => {
  dispatch(setIsActiveSpinner(true));
  try {
    const upload = await DocumentService.uploadDocument(type, accountId, files, case_id, removal_order_id);

    if (!upload) throw new Error("Upload failed");

    let documents: any[] = [];
    if (upload.message === "success" || upload.message === "partial_success") {
      documents = await getDocuments(dispatch, type, accountId, case_id, index);
    }

    return { upload, documents };
  } catch (error) {
    console.error("getDocuments failed", { error, type, accountId });
    throw new Error("Could not fetch documents", { cause: error });
  }
  finally {
    dispatch(setIsActiveSpinner(false));
  }
};
